module.exports = __webpack_public_path__ + "static/img/product1-2.decfdb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product1-2.jpg
// module id = DlJH
// module chunks = 0